import { render } from "./SaleCard.vue?vue&type=template&id=9048a888&scoped=true"
import script from "./SaleCard.vue?vue&type=script&lang=js"
export * from "./SaleCard.vue?vue&type=script&lang=js"

import "./SaleCard.vue?vue&type=style&index=0&id=9048a888&scoped=true&lang=css"

import exportComponent from "/home/elias/web-farm/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9048a888"]])

export default __exports__